//const website = require('./website')

module.exports = {
  fr: {
    default: true,
    label: "Fr",
    path: "fr",
    locale: "fr",
    siteLanguage: "fr",
    ogLang: "fr_FR",
    link: "lien",
    image: "image",
    atc: "AJOUTER AU PANIER",
    color: "COULEUR"
  },
  en: {
    default: false,
    label: "En",
    path: "en",
    locale: "en",
    siteLanguage: "en",
    ogLang: "en_GB",
    link: "link",
    image: "image",
    atc: "ADD TO CART",
    color: "COLOR"
  }
};
